import { useParams, Link } from 'react-router-dom';
import { useMemo } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import MovieCard from '@/components/feature/MovieCard';
import { movieCategories, getMoviesByCategory } from '@/mocks/movies';

export default function Category() {
  const { slug } = useParams<{ slug: string }>();

  const currentCategory = useMemo(() => {
    return movieCategories.find(c => c.slug === slug) || movieCategories[0];
  }, [slug]);

  const movies = useMemo(() => {
    return getMoviesByCategory(slug || 'all');
  }, [slug]);

  const breadcrumbItems = [
    { label: '首页', href: '/' },
    { label: currentCategory.name },
  ];

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <div className="pt-20">
        <div className="max-w-7xl mx-auto">
          <Breadcrumb items={breadcrumbItems} />

          <div className="w-full px-4 md:px-8">
            <div className="flex items-center gap-3 mb-8">
              <div className="w-12 h-12 flex items-center justify-center bg-accent-100 rounded-full">
                <i className={`${currentCategory.icon} text-accent-500 text-xl`}></i>
              </div>
              <div>
                <h1 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
                  {currentCategory.name}
                </h1>
                <p className="text-sm text-foreground-500 mt-0.5">
                  共 {movies.length} 部电影
                </p>
              </div>
            </div>

            {/* Sub-category tabs */}
            <div className="flex items-center gap-2 overflow-x-auto pb-3 flex-wrap mb-8">
              {movieCategories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className={`px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-all cursor-pointer flex items-center gap-1.5 ${
                    slug === cat.slug || (!slug && cat.slug === 'all')
                      ? 'bg-primary-500 text-white'
                      : 'bg-background-100 text-foreground-600 hover:bg-background-200 border border-background-200'
                  }`}
                >
                  <i className={`${cat.icon} text-sm`}></i>
                  {cat.name}
                </Link>
              ))}
            </div>

            {movies.length > 0 ? (
              <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 gap-4 md:gap-5">
                {movies.map((movie) => (
                  <MovieCard key={movie.id} {...movie} />
                ))}
              </div>
            ) : (
              <div className="text-center py-20">
                <i className="ri-movie-line text-5xl text-foreground-300 mb-4 block"></i>
                <p className="text-foreground-500 text-lg">该分类暂无电影</p>
                <Link to="/" className="text-primary-500 hover:text-primary-600 mt-3 inline-block text-sm font-medium cursor-pointer">
                  返回首页
                </Link>
              </div>
            )}
          </div>
        </div>
      </div>

      <div className="mt-16">
        <Footer />
      </div>
    </div>
  );
}